import * as types from '../actions/actionTypes';

const initialState = {
	flowSessionResponse: null,
	debugMode: false,
	debugParam: false,
	questions: [],
};

export default function reducer(state = initialState, action) {
	switch (action.type) {
		// add code to set "default flow id" from config
		case types.GUIDED_RESPONSE_START_FLOW:
			return {
				...state,
				flowSessionResponse: null,
				isLoading: true,
			};
		case types.SET_GUIDED_RESPONSE_DEBUG_CONTEXT:
			return {
				...state,
				debugParam: action.contextCriteria.debug
			};
		case types.GUIDED_RESPONSE_START_FLOW_SUCCESS:
		case types.GUIDED_RESPONSE_CONTINUE_FLOW_SUCCESS:
		case types.GUIDED_RESPONSE_PREVIOUS_SUCCESS:
			return {
				...state,
				flowSessionResponse: action.payload.data,
			};
		case types.GUIDED_RESPONSE_SAVE_FINISHED_QUESTIONS: //TODO: This action type will be deprecated once new Resume endpoint for GR is implemented
			return {
				...state,
				questions: action.data,
			};
		case types.CLEAR_DECISION_SUPPORT: {
			return initialState;
		}
		default:
			return state;
	}
}
